import { Box } from "@mui/material";
import React, { ReactNode } from "react";

interface Props {
    margin: {
        size: ("small" | "medium" | "large"),
        applyTo: ("all" | "topbottom" | "leftright")
    },
    children?: ReactNode
}

const DefaultSpacing : React.FC<Props> = ({margin, children}) => {
    const marginSize = (margin?.size === "small" ? '0.5em' : (margin?.size === "large" ? '1.5em' : '1em'));

    return <Box sx={{margin: `${margin?.applyTo === "all" || margin?.applyTo === "topbottom" ? marginSize : '0'} ${margin?.applyTo === "leftright" ? marginSize : (margin?.applyTo === "topbottom" ? '0' : '')}`}}>{children}</Box>
}

export default DefaultSpacing;